import { Feature } from "../phonemes/features";
import { IpaType } from "../phonemes/ipa";

/** a phoneme item: IPA, phoneme features, arbitrary text, special operation, empty */
export type PhonemeInfo = IpaItem | FeatureItem | RawItem | SpecialItem | NamedItem | EmptyItem;

/** IPA phonemes */
export interface IpaItem {
  readonly ipa: IpaType[];
  /** true means 'ipa' could match a subset the target; default: false, means a complete match */
  readonly subset?: boolean;
}

/** phoneme features */
export interface FeatureItem {
  readonly feature: Feature[];
}

/** arbitrary string */
export interface RawItem {
  readonly raw: string[];
  /** true means 'raw' could match a subset the target; default: false, means a complete match */
  readonly subset?: boolean;
}

/** special matching operation */
export interface SpecialItem {
  readonly special:
  | 'word' // matches a word boundary
  | 'syllable' // matches syllable boundary
  ;
}
export const allSpecials = ['word', 'syllable'];

/** a named collection containing valid strings */
export interface NamedItem {
  readonly name: string;
}

/** used when a pattern doesn't have to match anything */
export interface EmptyItem {
  readonly empty: '';
}
